(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  function buildProvinceOptions(countrySelect, provinceSelect) {
    var selectedOption = countrySelect.options[countrySelect.selectedIndex];
    if (!selectedOption) return;

    var provinces = [];
    try {
      provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
    } catch (e) {
      provinces = [];
    }

    var wrapper = provinceSelect.closest('[data-province-wrapper]');
    var currentProvince = provinceSelect.getAttribute('data-current-province') || '';

    while (provinceSelect.firstChild) {
      provinceSelect.removeChild(provinceSelect.firstChild);
    }

    if (provinces.length === 0) {
      if (wrapper) wrapper.style.display = 'none';
      return;
    }

    if (wrapper) wrapper.style.display = '';

    for (var i = 0; i < provinces.length; i++) {
      var opt = document.createElement('option');
      opt.value = provinces[i][0];
      opt.textContent = provinces[i][1];
      if (currentProvince && (currentProvince === provinces[i][0] || currentProvince === provinces[i][1])) {
        opt.selected = true;
      }
      provinceSelect.appendChild(opt);
    }

    provinceSelect.setAttribute('data-current-province', '');
  }

  function initCountrySelect(countrySelect) {
    var addressId = countrySelect.getAttribute('data-address-country');
    var provinceSelect = document.querySelector('[data-address-province="' + addressId + '"]');
    if (!provinceSelect) return;

    buildProvinceOptions(countrySelect, provinceSelect);

    countrySelect.addEventListener('change', function () {
      buildProvinceOptions(countrySelect, provinceSelect);
    });
  }

  document.querySelectorAll('[data-address-country]').forEach(initCountrySelect);

  document.addEventListener('click', function (e) {
    var editBtn = e.target.closest('[data-edit-address]');
    if (editBtn) {
      var id = editBtn.getAttribute('data-edit-address');
      var form = document.querySelector('[data-edit-form="' + id + '"]');
      if (!form) return;
      var isHidden = form.hidden;
      form.hidden = !isHidden;
      editBtn.setAttribute('aria-expanded', String(isHidden));
      if (isHidden) {
        var firstInput = form.querySelector('input, select, textarea, button');
        if (firstInput) firstInput.focus();
      }
      return;
    }

    var cancelBtn = e.target.closest('[data-cancel-edit]');
    if (cancelBtn) {
      var cid = cancelBtn.getAttribute('data-cancel-edit');
      var cform = document.querySelector('[data-edit-form="' + cid + '"]');
      if (!cform) return;
      cform.hidden = true;
      var trigger = document.querySelector('[data-edit-address="' + cid + '"]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      return;
    }

    var deleteBtn = e.target.closest('[data-confirm]');
    if (deleteBtn) {
      var msg = deleteBtn.getAttribute('data-confirm');
      if (!window.confirm(msg)) {
        e.preventDefault();
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var section = document.getElementById('recently-viewed');
      if (!section) return;

      var raw = null;
      try {
        raw = localStorage.getItem('kissa_recently_viewed');
      } catch (e) {
        return;
      }

      if (!raw) return;

      var items = null;
      try {
        items = JSON.parse(raw);
      } catch (e) {
        return;
      }

      if (!Array.isArray(items) || items.length === 0) return;

      var grid = section.querySelector('.search-page__recent-grid');
      if (!grid) return;

      var shown = items.slice(0, 6);

      shown.forEach(function (item) {
        if (!item || typeof item !== 'object') return;

        var li = document.createElement('li');
        li.className = 'search-page__recent-item';

        var a = document.createElement('a');
        a.href = typeof item.url === 'string' ? item.url : '#';
        a.className = 'search-page__recent-card';

        if (typeof item.image === 'string' && item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = typeof item.title === 'string' ? item.title : '';
          img.className = 'search-page__recent-image';
          img.loading = 'lazy';
          img.width = 200;
          img.height = 267;
          a.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'search-page__recent-info';

        if (typeof item.title === 'string' && item.title) {
          var titleEl = document.createElement('p');
          titleEl.className = 'search-page__recent-title';
          titleEl.textContent = item.title;
          info.appendChild(titleEl);
        }

        if (typeof item.price === 'string' && item.price) {
          var priceEl = document.createElement('p');
          priceEl.className = 'search-page__recent-price';
          priceEl.textContent = item.price;
          info.appendChild(priceEl);
        }

        a.appendChild(info);
        li.appendChild(a);
        grid.appendChild(li);
      });

      section.removeAttribute('hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
